import type { PortfolioConnectionPublic, PortfolioPluginKind } from '@workspace/types';

export type SetupConnectionFields = {
  pluginKind: PortfolioPluginKind;
  name: string;
  host: string;
  port: string;
  database: string;
  username: string;
  idempresa: string;
  useCobradorViews: boolean;
};

export function emptySetupFields(): SetupConnectionFields {
  return {
    pluginKind: 'SETUP_MSSQL',
    name: 'Setup',
    host: '',
    port: '1433',
    database: '',
    username: '',
    idempresa: '',
    useCobradorViews: false,
  };
}

export function fieldsFromConnection(
  connection: PortfolioConnectionPublic | null | undefined,
): SetupConnectionFields {
  if (!connection) {
    return emptySetupFields();
  }
  const options = connection.options as { idempresa?: number; portfolioSource?: string } | null;
  return {
    pluginKind: connection.pluginKind,
    name: connection.name,
    host: connection.host ?? '',
    port: String(connection.port ?? 1433),
    database: connection.database ?? '',
    username: connection.username ?? '',
    idempresa: options?.idempresa != null ? String(options.idempresa) : '',
    useCobradorViews: options?.portfolioSource === 'views',
  };
}
